import React, {HTMLAttributes} from 'react';
import {AccordionLocalizedHeadline, AccordionWrapper} from './Accordion.style';

export interface AccordionProps extends HTMLAttributes<HTMLDivElement> {
    readonly localizedHeadline: string;
}

/**
 * @name Accordion
 * @description
 * Generic component to create show an accordion with header and closable content area
 */
export const Accordion = React.forwardRef<HTMLDivElement, AccordionProps>(
    ({localizedHeadline, children}, ref) => {

        return (
            <AccordionWrapper ref={ref}>
                <AccordionLocalizedHeadline className='a-accordion__headline'>
                    {localizedHeadline}
                </AccordionLocalizedHeadline>
                <div>{children}</div>
            </AccordionWrapper>
        );
    }
);

Accordion.displayName = 'Accordion';
